import React from 'react'
import { render } from 'react-dom'
import Cookie from 'js-cookie'
import store from './store'
import * as merchantUserActions from 'actions/merchantUser'
import { getMerchant } from 'actions/merchant'
import * as authActions from 'actions/auth'
import { updateRedirect } from 'actions/redirect'
import App from './scenes/App'
// $FlowFixMe
import urlUtils from 'utilities/urlUtils'
import { push } from 'react-router-redux'
import { I18n } from 'react-redux-i18n'
import ReactGA from 'react-ga'
import AppProviders from 'components/AppProviders'
import './index.scss'
import { isLegalPage } from 'utilities/pages'
import { errorHandler } from 'utilities/errorHandler'
import { initializeDatadog } from 'utils/analytics/datadog'

if (process.env.REACT_APP_GOOGLE_ANALYTICS_UID) {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_UID)
}

require('utilities/formsyValidators')
require('typeface-lato')
require('typeface-roboto-mono')

if (process.env.REACT_APP_SENTRY_DSN) {
  // Guarded: raven-js is a blockable CDN script; an unguarded call here throws
  // before render() and blanks #root — the one spot no ErrorBoundary can reach.
  errorHandler.init(process.env.REACT_APP_SENTRY_DSN)
}

initializeDatadog()

I18n.setHandleMissingTranslation(() => undefined)

let passwordAuth = Cookie.getJSON('thanx-auth-password') || {}
let isAuthPage = urlUtils.matchPath('/auth', false)
let isInvitationPage = urlUtils.matchPath('/invitation', false)

if (passwordAuth.access_token && passwordAuth.current_merchant_user_id) {
  store.dispatch({
    ...passwordAuth,
    type: authActions.STORE_AUTH_DATA,
  })

  if (passwordAuth.current_merchant_id) {
    Promise.all([
      store.dispatch(merchantUserActions.getCurrentMerchantUser(store)),
      store.dispatch(getMerchant(passwordAuth.current_merchant_id, store)),
    ])
  } else {
    store.dispatch(push('/choose'))
  }
} else if (!isAuthPage && !isLegalPage() && !isInvitationPage) {
  store.dispatch(updateRedirect(window.location.pathname))
  store.dispatch(push('/auth/login'))
}

render(
  <AppProviders>
    <App />
  </AppProviders>,
  document.getElementById('root')
)

const browserNav = window.navigator
if (typeof browserNav !== 'undefined') {
  if ('serviceWorker' in browserNav) {
    browserNav.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}
